import React from 'react';
import { UiKit } from '@datavant/idsb-shared/uikit';

export const TutorialModal = (props: { isOpen: boolean; onClose: () => void }): JSX.Element => {
    const modalTitle = 'Provider Portal Tutorial';
    const modalBody = (
        <UiKit.Chakra.Box className="ag-theme-alpine">
            <video
                controls={true}
                width={'100%'}
                height={'100%'}
                preload="metadata"
                poster="/rm-basic/rm-tutorial-thumbnail.png"
                data-testid="rm-video"
            >
                <source src="/rm-basic/rm-basic-tutorial.mp4" type="video/mp4" />
            </video>
        </UiKit.Chakra.Box>
    );

    return (
        <UiKit.Modal
            bodyFragment={modalBody}
            footerFragment={null}
            title={modalTitle}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'xl'}
        />
    );
};
